import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import AllTables from "./AllTables";
import Alphabet from "./Alphabet";
import GridView from "./GridView";
import { useSearchParams } from "react-router-dom";
import GridAlphabetScroll from "./GridAlphabetScroll";
// import Layout from '../Layout/Layout';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props: {
  page: number;
  pageSize: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  gridPage: number;
  gridPageSize: number;
  setGridPage: React.Dispatch<React.SetStateAction<number>>;
  setGridPageSize: React.Dispatch<React.SetStateAction<number>>;
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabFromURL = searchParams.get("tab");

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setSearchParams({ tab: newValue.toString() });
  };

  React.useEffect(() => {
    if (tabFromURL && parseInt(tabFromURL) !== value) {
      setValue(parseInt(tabFromURL, 10));
    }
  }, [tabFromURL, value]);


  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="List" {...a11yProps(0)} />
          <Tab label="Grid" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Alphabet />
        <AllTables
          page={props.page}
          pageSize={props.pageSize}
          setPage={props.setPage}
          setPageSize={props.setPageSize}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <GridAlphabetScroll />
        <GridView
          gridPageSize={props.gridPageSize}
          setGridDataSize={props.setGridPageSize}
          page={props.gridPage}
          setPage={props.setGridPage}
        />
      </CustomTabPanel>
    </Box>
  );
}
